import { Box, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

export const Wrapper = styled(Box)`
  margin: 20px 0;
  max-width: 125px;

  ${({ theme }) => css`
    margin-right: ${theme.newSpaces.xs2}px;

    ${theme.below.laptop`
      min-width: 145px;

      &:nth-child(n) {
        margin-left: 0;
      }

      &:nth-child(2n) {
        margin-right: 0;
      }

      &:nth-last-child(n + 2) {
        margin-right: 15px;
      }
    `}

    ${theme.below.tablet`
      margin-bottom: ${theme.newSpaces.xs}px;

      &:nth-child(n) {
        margin-left: 0;
      }
    `}

    ${theme.below.mobileXL`
      max-width: 135px;

      &:nth-child(n) {
        margin-top: 0;
        margin-bottom: ${theme.newSpaces.md}px;
        margin-right: ${theme.newSpaces.xs}px;
      }
    `}

    ${theme.below.mobileM`
      max-width: 130px;

      &:nth-child(n) {
        margin-top: 0;
        margin-bottom: ${theme.newSpaces.md}px;
        margin-right: ${theme.newSpaces.xs3}px;
      }
    `}
  `};
`

export const Amount = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('mobile', 'body', 'body3')};

    color: ${theme.newColors.accent};
  `}
`

export const Role = styled(Amount)`
  ${({ theme }) => css`
    ${theme.getTypography('mobile', 'preText', 'text1')};

    border-bottom: 2px solid ${theme.newColors.coldGray};
    color: ${theme.newColors.darkGray};

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body4')};
    `}
  `}
`
